export function replaceZerosWithHyphen(numberID: number | string) {
  const id = (numberID || '').toString();
  if (id.includes('-')) return id;
  let lastZero = 2;
  for (let i = lastZero; i < id.length; i++) {
    if (id.charAt(i) !== '0') {
      lastZero = i;
      break;
    }
  }
  const modifiedID = `${id.substring(0, 2)}-${id.substring(lastZero)}`;
  return modifiedID;
}
